/* eslint-disable no-underscore-dangle */
import { useCallback, useEffect, useState } from 'react';

import {
  SALESFORCE_DEPLOYMENT_ID,
  SALESFORCE_LIVE_CHAT_HOST,
  SALESFORCE_LIVE_CHAT_ID,
  SALESFORCE_LIVE_CHAT_SCRIPT,
  SALESFORCE_ORG_ID,
} from '@/config';
import captureErrorInSentry from '@/utils/captureErrorInSentry';
import loadScript from '@/utils/loadScript';

const useLiveAgent = ({ liveChatOnlineElement, liveChatOfflineElement }) => {
  const [hasInitialized, setInitialized] = useState(false);
  const [hasLoadingError, setLoadingError] = useState(false);

  const initializeAgent = useCallback(() => {
    if (!window.liveagent) return;

    window.liveagent.init(
      `${SALESFORCE_LIVE_CHAT_HOST}/chat`,
      SALESFORCE_DEPLOYMENT_ID,
      SALESFORCE_ORG_ID,
    );

    window._laq = window._laq || [];
    window._laq.push(() => {
      window.liveagent.showWhenOnline(
        SALESFORCE_LIVE_CHAT_ID,
        document.getElementById(liveChatOnlineElement),
      );
      window.liveagent.showWhenOffline(
        SALESFORCE_LIVE_CHAT_ID,
        document.getElementById(liveChatOfflineElement),
      );
    });
  }, [liveChatOfflineElement, liveChatOnlineElement]);

  const loadLiveAgent = useCallback(() => {
    loadScript(SALESFORCE_LIVE_CHAT_SCRIPT)
      .then(() => {
        initializeAgent();
        setInitialized(true);
      })
      .catch((e) => {
        setLoadingError(true);
        captureErrorInSentry(e);
      });
  }, [initializeAgent]);

  const startChat = useCallback(() => {
    window.liveagent.startChat(SALESFORCE_LIVE_CHAT_ID);
  }, []);

  useEffect(() => {
    if (!hasInitialized) loadLiveAgent();
  }, [hasInitialized, loadLiveAgent]);

  return {
    startChat,
    hasInitialized,
    hasLoadingError,
  };
};

export default useLiveAgent;
